import React from "react";
import { useParams } from "react-router-dom";

import Page from "../../components/Page";
import DocumentForm from "../../components/sections/document/DocumentForm";

const Document = () => {
  const { id } = useParams();
  const title = id ? "Edit document" : "Add document";

  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "/documents",
      breadcrumbName: "Documents",
    },
    {
      path: "",
      breadcrumbName: title,
    },
  ];
  return (
    <>
      <Page title={title} breadcrumb={breadcrumb}>
        <div className="page-container">
          <div className="page-padding-leftRight page-padding-topBottom">
            <DocumentForm />
          </div>
        </div>
      </Page>
    </>
  );
};

export default Document;
